import React from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  DetailViewWrapper,
  MainContainer,
  StyledActionButtonContainer,
} from './styles';
import SecurityTrim from '../../../../services/auth/SecurityTrim';
import ActionButton from '../../../components/ActionButton/ActionButton';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { useI18n } from '../../../../hooks/useI18n';
import DocumentList from '../../documents/DocumentsList/DocumentsLists';
import {
  CropConnectRoleDefinitions,
  DocumentFolder,
} from '../../../../services/cropConnectApiClient';
import PageHeader from '../../../layout/PageHeader/PageHeader';
import AllIndividualDocumentsList from '../AllIndividualDocumentsList/AllIndividualDocumentsList';
import DocumentListWithPrefilter from '../../documents/DocumentsListWithPrefilter/DocumentsListWithPrefilter';

const IndividualDocumentsComponent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useI18n();

  const folder = searchParams.get('folder'); // "newsletter"
  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.individual_documents_title)} />
      <DetailViewWrapper>
        <StyledActionButtonContainer>
          <ActionButton
            variant="link-button"
            buttonText={t(TranslationKeys.common_back_to_overview)}
            onClickAction={() => window.history.back()}
            back={true}
          />
        </StyledActionButtonContainer>

        {folder == 'newsletters' && (
          <SecurityTrim
            requiredBusinessPartnerRoles={[
              CropConnectRoleDefinitions.Grower_DE,
              CropConnectRoleDefinitions.Grower_Organic_DE,
              CropConnectRoleDefinitions.Grower_FI,
            ]}
          >
            <DocumentList
              folder={DocumentFolder.MyNewsletter}
              title={t(
                TranslationKeys.individual_documents_main_newsletters_title
              )}
              showExtraButton={false}
              hideInvoiceColumn={true}
            />
          </SecurityTrim>
        )}
        {folder == 'anbauempfehlung' && (
          <SecurityTrim
            requiredBusinessPartnerRoles={[
              CropConnectRoleDefinitions.Grower_DE,
              CropConnectRoleDefinitions.Grower_Organic_DE,
            ]}
          >
            <DocumentListWithPrefilter
              folder={DocumentFolder.MyBusinessInfoBeet}
              title={t(
                TranslationKeys.individual_documents_main_anbauempfehlung_title
              )}
              showExtraButton={false}
              hideInvoiceColumn={true}
              prefilter="anbauempfehlung"
              hideCalendarYearColumn={true}
            />
          </SecurityTrim>
        )}
        {folder == 'liefermitteilungen' && (
          <SecurityTrim
            requiredBusinessPartnerRoles={[
              CropConnectRoleDefinitions.Grower_DE,
              CropConnectRoleDefinitions.Grower_Organic_DE,
            ]}
          >
            <DocumentListWithPrefilter
              folder={DocumentFolder.MyPayments}
              title={t(
                TranslationKeys.individual_documents_main_liefermitteilungen_title
              )}
              showExtraButton={false}
              hideInvoiceColumn={true}
              prefilter="liefermitteilungen"
            />
          </SecurityTrim>
        )}
        {folder == 'all' && (
          <SecurityTrim
            requiredBusinessPartnerRoles={[CropConnectRoleDefinitions.Grower]}
          >
            <AllIndividualDocumentsList
              hideInvoiceColumn={true}
              showInvoiceNumber={false}
              title={t(TranslationKeys.all_individual_documents_list_title)}
              showExtraButton={false}
            />
          </SecurityTrim>
        )}
      </DetailViewWrapper>
    </MainContainer>
  );
};

export default IndividualDocumentsComponent;
